import { Link } from '@tanstack/react-router'
import type { components } from '@/api/schema'
import { cn } from '@/lib/utils'

export type DataSourceEmail = components['schemas']['DataSourceEmailRead']

/**
 * "From email →": the data@ email a price, discount or lead time came from, opened on the manufacturer's
 * Emails tab (USA-796). Renders nothing for changes staff or jobs made.
 */
export function SourceEmailLink({
  source,
  className,
}: {
  source: DataSourceEmail | null | undefined
  className?: string
}) {
  if (!source) return null
  return (
    <Link
      to="/manufacturers/$manuId"
      params={{ manuId: source.manufacturer_uuid }}
      search={{ tab: 'emails', message: String(source.message_id) }}
      className={cn('font-medium text-primary hover:underline', className)}
    >
      From email →
    </Link>
  )
}
